//This might just be stupid enough to work
import $ from "jquery"

window.$ = window.jQuery = $;